import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import ContentHeader from "components/ContentHeader/ContentHeader"

import { exposeStyles } from "helpers/components"

import DeviceSectionText from "./text"
import DeviceSectionImage from "./image"

import styles from "./deviceSection.css"

const DeviceSection = ({ children, customStyle, imageAlt, imageCustomStyle, reverse = false, srcSet, title, textCustomStyle }) => (
  <section className={classnames(ContentHeader.above, styles.section, customStyle)}>
    <div className={styles.wrapper}>
      {reverse ? <DeviceSectionImage srcSet={srcSet} imageAlt={imageAlt} customStyle={classnames(imageCustomStyle, styles.reverseImage)} /> : null}
      <DeviceSectionText title={title} text={children} customStyle={textCustomStyle} />
      <DeviceSectionImage srcSet={srcSet} imageAlt={imageAlt} customStyle={classnames(imageCustomStyle, { [styles.reverseImageMobile]: reverse })} />
    </div>
  </section>
)

DeviceSection.propTypes = {
  children: PropTypes.node.isRequired,
  customStyle: PropTypes.string,
  imageAlt: PropTypes.string,
  imageCustomStyle: PropTypes.string,
  reverse: PropTypes.bool,
  srcSet: PropTypes.array.isRequired,
  textCustomStyle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
}

export default exposeStyles(DeviceSection, styles)
